import { render, staticRenderFns } from "./SavedInput.vue?vue&type=template&id=4f6a21c6&scoped=true&"
import script from "./SavedInput.vue?vue&type=script&lang=js&"
export * from "./SavedInput.vue?vue&type=script&lang=js&"
import style0 from "./SavedInput.vue?vue&type=style&index=0&id=4f6a21c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6a21c6",
  null
  
)

export default component.exports